import '@jack-henry/jh-ui/components/card/card.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../../tm-base.component';

export const tagName = 'tm-jh-card';
@customElement(tagName)
export class TmCard extends TmBaseComponent {
    @property()
    public padding: 'medium' | 'small' | 'none' = 'medium';

    protected render() {
        return html`<jh-card class="rounded-none shadow-none" .padding=${this.padding}>
            <slot></slot>
        </jh-card>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmCard;
    }
}
